<template>
  <div>
    <v-card class="mx-auto" outlined >
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" dark small class="float-end" @click="Save">
                 {{ $t("btn.Save") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-textarea
              outlined
              rows="4"
              label="คุณค่าหลัก"
              v-model="value"
            ></v-textarea>
          </v-col>
          <v-col cols="4">
            <v-textarea
              outlined
              rows="4"
              label="วิสัยทัศน์"
              v-model="vision"
            ></v-textarea>
          </v-col>
          <v-col cols="4">
            <v-textarea
              outlined
              rows="4"
              label="พันธกิจ"
              v-model="mission"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogComplete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          บันทึกข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogComplete=false">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  export default {
    components: {
    },
    data() {
      return {
        dialogComplete:false,
        value:'',
        vision:'',
        mission:'',
      };
    },

    methods: {
      GetData(){

      },
      Save(){
         this.$store.commit('set_overlay',true);
          let formData = new FormData();
          formData.append('Value',this.value);
          formData.append('Vision',this.vision);
          formData.append('Mission',this.mission);
          formData.append('locale',this.$store.getters.authen.locale);
          this.req.post(this.$store.getters.base_api + 'post-topic-aboutus',formData,{ headers: {'Content-Type': 'multipart/form-data'},})
                .then(response=>{
                  this.dialog = false;
                  this.dialogComplete = true;
                  this.$store.commit('set_overlay',false);
               }).catch(error => {
                  this.$store.commit('set_overlay',true);
              });
      }
    },
    mounted() {
      this.req = this.$store.getters.req;
    },



  };
</script>
